var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference path="../../typings/tsd.d.ts" /> 
var warsApp;
(function (warsApp) {
    var services;
    (function (services) {
        var DeleteService = /** @class */ (function (_super) {
            __extends(DeleteService, _super);
            function DeleteService($http, $q, modalService, growl, dataService) {
                var _this = _super.call(this, $http) || this;
                _this.$q = $q;
                _this.modalService = modalService;
                _this.growl = growl;
                _this.dataService = dataService;
                return _this;
            }
            DeleteService.prototype.delete = function (name, id) {
                var params = {};
                this.handlerUrl = "api/Delete/SafeDelete/" + name + "/" + id;
                return this.usePostHandler(params);
            };
            DeleteService.prototype.deleteRecursivelyWithoutWarning = function (name, id, ignoreUnsavedChanges) {
                if (!ignoreUnsavedChanges && this.dataService.hasChanges()) {
                    this.growl.error("Please save all in-work changes before attempting this delete action", { ttl: 5000 });
                    var deferred = this.$q.defer();
                    var failureResult = {
                        entityName: name,
                        entityId: id,
                        wasSuccessful: false,
                        inWorkChangesExist: true
                    };
                    deferred.resolve(failureResult);
                    return deferred.promise;
                }
                var params = {};
                this.handlerUrl = "api/Delete/RecursiveDelete/" + name + "/" + id;
                return this.usePostHandler(params);
            };
            DeleteService.prototype.deleteBatchRecursivelyWithoutWarning = function (deleteInfo, ignoreUnsavedChanges) {
                if (!ignoreUnsavedChanges && this.dataService.hasChanges()) {
                    this.growl.error("Please save all in-work changes before attempting this delete action", { ttl: 5000 });
                    var deferred = this.$q.defer();
                    var failureResult = {
                        wasSuccessful: false,
                        inWorkChangesExist: true
                    };
                    deferred.resolve(failureResult);
                    return deferred.promise;
                }
                this.handlerUrl = "api/Delete/RecursiveDeleteBundle";
                return this.usePostHandler(deleteInfo);
            };
            DeleteService.prototype.deleteWithModalConfirmationIfNecessary = function (name, id, successMessage, successCallback, failureMessage, failureCallback) {
                var _this = this;
                if (this.dataService.hasChanges()) {
                    this.growl.error("Please save all in-work changes before attempting this delete action", { ttl: 5000 });
                    return;
                }
                else {
                    this.delete(name, id).then(function (deleteResult) {
                        if (deleteResult.wasSuccessful) {
                            _this.processSuccessfulDelete(deleteResult, successMessage, successCallback);
                        }
                        else {
                            _this.showDeleteModal(deleteResult, successCallback, successMessage, failureCallback, failureMessage);
                        }
                    });
                }
            };
            //Use this one:
            DeleteService.prototype.deleteWithModalConfirmIfNecessary = function (entityName, id, messagePrefix, successCallback, failureCallback) {
                this.deleteWithModalConfirmationIfNecessary(entityName, id, messagePrefix + " successfully deleted", successCallback, messagePrefix + " could not be deleted", failureCallback);
            };
            DeleteService.prototype.processSuccessfulDelete = function (deleteResult, successMessage, successCallback) {
                if (successMessage)
                    this.growl.success(successMessage, { ttl: 5000 });
                this.dataService.resolveDeletesAndUpdatesPerformedOutsideOfBreeze(deleteResult);
                if (successCallback)
                    successCallback();
            };
            DeleteService.prototype.showDeleteModal = function (deleteResult, successCallback, successMessage, failureCallback, failureMessage) {
                var _this = this;
                this.modalService.showModal({
                    templateUrl: "./app/views/modals/deleteModal.html",
                    controller: "deleteModalController",
                    size: 'lg',
                    inputs: {
                        deleteResult: deleteResult
                    }
                }).then(function (modal) {
                    // The modal object has the element built, if this is a bootstrap modal
                    // you can call 'modal' to show it, if it's a custom modal just show or hide
                    // it as you need to.                
                    modal.element.modal();
                    modal.close.then(function (result) {
                        // Only true if not a cancel
                        if (result && result.cancel === false) {
                            if (result.deleteResult && result.deleteResult.wasSuccessful) {
                                _this.processSuccessfulDelete(result.deleteResult, successMessage, successCallback);
                            }
                            else {
                                if (failureMessage)
                                    _this.growl.error(failureMessage, { ttl: 5000 });
                                if (failureCallback)
                                    failureCallback(result.deleteResult);
                            }
                        }
                    });
                });
            };
            return DeleteService;
        }(services.HttpHandlerService));
        services.DeleteService = DeleteService;
    })(services = warsApp.services || (warsApp.services = {}));
})(warsApp || (warsApp = {}));
warsApp.registerService("DeleteService", ["$http", "$q", "ModalService", "growl", "dataService"]);
